/**
 * FT13-U20: Disposals (FSD 2.2.4.3 Dispose, 2.2.4.10 Disposal Gain and Loss
 * Analysis) and the per-legal-entity asset settings (2.2.4.8: disposal above a
 * threshold needs dual approval; FIN-F04-V08 impairment authority; the CIP
 * account Capitalise From Source reads).
 *
 * The INT packet spreads `ASSETS_DISPOSALS_ROUTES` and adds nav items
 * `assets-disposals` and `assets-settings`. Each route's permission is its
 * read endpoint's: `GET /asset-disposals` (assets.asset.read) and
 * `GET /asset-settings/{companyId}` (assets.class.read).
 */

import type { RouteRecordRaw } from 'vue-router'

import { ASSETS_PERMISSIONS } from '@/modules/assets/permissions'

export const DISPOSALS_PATH = '/assets/disposals'
export const ASSET_SETTINGS_PATH = '/assets/settings'

/** The disposals list, pre-filtered — what an asset's pending badge drills through to. */
export function disposalsRoute(params: {
  assetId?: number | null
  companyId?: number | null
  method?: string
  status?: string
  disposal?: number | null
}): string {
  const query = new URLSearchParams()
  if (params.companyId !== undefined && params.companyId !== null) query.set('companyId', String(params.companyId))
  if (params.assetId !== undefined && params.assetId !== null) query.set('assetId', String(params.assetId))
  if (params.method !== undefined && params.method !== '') query.set('method', params.method)
  if (params.status !== undefined && params.status !== '') query.set('status', params.status)
  if (params.disposal !== undefined && params.disposal !== null) query.set('disposal', String(params.disposal))
  const qs = query.toString()
  return qs === '' ? DISPOSALS_PATH : `${DISPOSALS_PATH}?${qs}`
}

export const ASSETS_DISPOSALS_ROUTES: RouteRecordRaw[] = [
  {
    path: DISPOSALS_PATH,
    name: 'assets-disposals',
    component: () => import('@/modules/assets/disposals/DisposalsView.vue'),
    meta: {
      titleKey: 'assets.routeTitles.disposals',
      permission: ASSETS_PERMISSIONS.assetRead,
    },
  },
  {
    path: ASSET_SETTINGS_PATH,
    name: 'assets-settings',
    component: () => import('@/modules/assets/disposals/AssetSettingsView.vue'),
    meta: {
      titleKey: 'assets.routeTitles.settings',
      permission: ASSETS_PERMISSIONS.classRead,
    },
  },
]
